/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_nav_increase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentage Increase`)
};

const es_pct_nav_increase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aumento Porcentual`)
};

const de_pct_nav_increase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prozentualer Anstieg`)
};

const nl_pct_nav_increase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentagestijging`)
};

const fr_pct_nav_increase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Augmentation en pourcentage`)
};

const it_pct_nav_increase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aumento percentuale`)
};

const pt_br2_pct_nav_increase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aumento Percentual`)
};

const pt_pct_nav_increase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aumento Percentual`)
};

const ja_pct_nav_increase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーセント増加`)
};

const zh_pct_nav_increase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`百分比增长`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_nav_increase = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_nav_increase(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_nav_increase", locale)
	if (locale === "en") return en_pct_nav_increase(inputs)
	if (locale === "es") return es_pct_nav_increase(inputs)
	if (locale === "de") return de_pct_nav_increase(inputs)
	if (locale === "nl") return nl_pct_nav_increase(inputs)
	if (locale === "fr") return fr_pct_nav_increase(inputs)
	if (locale === "it") return it_pct_nav_increase(inputs)
	if (locale === "pt-BR") return pt_br2_pct_nav_increase(inputs)
	if (locale === "pt") return pt_pct_nav_increase(inputs)
	if (locale === "ja") return ja_pct_nav_increase(inputs)
	return zh_pct_nav_increase(inputs)
};